export default __webpack_public_path__ + "static/media/case-closed.f1e7b1e2.mp3";